import {createAsyncThunk} from "@reduxjs/toolkit";
import {api} from "../../config/api";

export const fetchStats = createAsyncThunk(
    "property/fetchStats",
    async ({ selectedMonth }) => {
        const response = await api.get(`/adminDashboard/monthly/${selectedMonth}`)
        return response.data;
    }
);

export const fetchChart = createAsyncThunk(
    "property/fetchChart",
    async () => {
        const response = await api.get(`/adminDashboard/by-month`)
        console.log('AAAAA', response)
        return response.data;
    }
);